import { FC } from "react";

// --
// -- The shared spinner: a ring that expands and fades, over and over.
// --
// -- Note `attributeName` takes the SVG spelling, not React's. React camel-cases
// -- props - strokeWidth becomes stroke-width on the element - but these are
// -- plain string values, so "strokeWidth" here names an attribute that does
// -- not exist and the animation silently never runs. That left the circle at
// -- its static 0.5 user units, which over a 200-unit viewBox drawn at 3em is
// -- about a tenth of a CSS pixel: the spinner painted nothing at all, and
// -- every loading state in the app looked like a blank pause.
// --
const Loading : FC<{
  isfullScreen?: boolean,
  size?: 'tyny' | 'small' | 'medium' | 'large',
}>  = ({
  isfullScreen,
  size = 'medium',
}) => (
  <div className={`flex justify-center w-[100%] ${isfullScreen ? 'h-screen items-center' : ''}`}>
    {/*
      Every size needs real dimensions. The svg carries a viewBox but no
      width or height of its own, so a box with neither collapses and the
      spinner disappears - the same invisible-spinner trap by another route.
    */}
    <div className={`${{
      'tyny':   'w-[2em] h-[2em]',
      'small':  'w-[2.5em] h-[2.5em]',
      'medium': 'w-[4em] h-[4em]',
      'large':  'w-[6em] h-[6em]',
    }[size]}`}>
      {/*
        Mid grey rather than the near-white it used to be. The ring fades to
        transparent as it grows, so the colour it starts from is what decides
        whether the whole animation reads as anything at all: at #cccccc the
        darkest pixel in a cycle came out at 226/255, which is hard to tell
        from a rendering artefact.
      */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <circle fill="none" strokeOpacity="1" stroke="#9ca3af" strokeWidth="0.5" cx="100" cy="100" r="0">
          <animate attributeName="r" calcMode="spline" dur="2s" values="1;80" keyTimes="0;1" keySplines="0 .2 .5 1" repeatCount="indefinite"></animate>
          <animate attributeName="stroke-width" calcMode="spline" dur="2s" values="0;25" keyTimes="0;1" keySplines="0 .2 .5 1" repeatCount="indefinite"></animate>
          <animate attributeName="stroke-opacity" calcMode="spline" dur="2s" values="1;0" keyTimes="0;1" keySplines="0 .2 .5 1" repeatCount="indefinite"></animate>
        </circle>
      </svg>
    </div>
  </div>
);

export default Loading;
